var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',_vm._l((_vm.navigations),function(navigation){return _c('side-menu-item',{key:navigation.id,attrs:{"navigation":navigation,"accordionId":"0"}})}))}
var staticRenderFns = []

export { render, staticRenderFns }